import React from "react";

export default function PoliticaETermos() {
  return (
    <div style={{ fontFamily: "Arial, sans-serif", margin: 20, lineHeight: 1.6, color: "#222" }}>
      <h1 style={{ fontSize: 26, marginTop: 40, marginBottom: 10 }}>
        POLÍTICA DE PRIVACIDADE DO PROJETO “MARCA AÍ”
      </h1>

      <section style={{ marginBottom: 40 }}>
        <h2 style={{ fontSize: 20, marginTop: 25 }}>Introdução</h2>
        <p>
          Esta Política de Privacidade descreve como o projeto “Marca Aí”
          (“Plataforma”, “nós”, “nosso”) coleta, usa, armazena e protege os dados
          pessoais de seus usuários, sejam eles Prestadores de Serviços
          (Administradores/Funcionários) ou Clientes.
        </p>
        <p>
          Ao utilizar a Plataforma “Marca Aí”, você concorda com a coleta e uso
          de suas informações conforme descrito nesta política.
        </p>

        <h2 style={{ fontSize: 20, marginTop: 25 }}>1. Controladora dos Dados Pessoais</h2>
        <p>O projeto “Marca Aí” atua como o controlador dos dados pessoais.</p>

        <h2 style={{ fontSize: 20, marginTop: 25 }}>
          2. Dados Pessoais Coletados e Finalidades
        </h2>
        <p>Coletamos apenas os dados essenciais ao funcionamento da Plataforma.</p>

        <h3 style={{ fontSize: 18, marginTop: 20 }}>2.1 Dados de Clientes</h3>
        <ul style={{ marginLeft: 20 }}>
          <li>Nome completo</li>
          <li>Número de WhatsApp</li>
          <li>Finalidade: gerenciamento de agendamentos</li>
          <li>Base legal: execução de contrato e legítimo interesse</li>
        </ul>

        <h3 style={{ fontSize: 18, marginTop: 20 }}>
          2.2 Dados de Prestadores / Funcionários
        </h3>
        <ul style={{ marginLeft: 20 }}>
          <li>Nome completo</li>
          <li>Telefone</li>
          <li>Foto (opcional)</li>
          <li>Senha criptografada</li>
        </ul>

        <h2 style={{ fontSize: 20, marginTop: 25 }}>3. Como Usamos Seus Dados</h2>
        <ul style={{ marginLeft: 20 }}>
          <li>Facilitar agendamentos</li>
          <li>Enviar notificações via WhatsApp</li>
          <li>Gerenciar clientes e serviços</li>
        </ul>

        <h2 style={{ fontSize: 20, marginTop: 25 }}>4. Compartilhamento de Dados</h2>
        <ul style={{ marginLeft: 20 }}>
          <li>Menuia – envio de mensagens</li>
          <li>Supabase – armazenamento</li>
        </ul>

        <h2 style={{ fontSize: 20, marginTop: 25 }}>5. Segurança dos Dados</h2>
        <ul style={{ marginLeft: 20 }}>
          <li>Criptografia</li>
          <li>Validação e proteção</li>
        </ul>

        <h2 style={{ fontSize: 20, marginTop: 25 }}>6. Retenção</h2>
        <p>Os dados são mantidos apenas pelo tempo necessário.</p>

        <h2 style={{ fontSize: 20, marginTop: 25 }}>7. Direitos do Titular</h2>
        <ul style={{ marginLeft: 20 }}>
          <li>Acesso, correção, exclusão etc.</li>
        </ul>

        <h2 style={{ fontSize: 20, marginTop: 25 }}>8. Cookies</h2>
        <p>Utilizamos cookies com consentimento prévio.</p>

        <h2 style={{ fontSize: 20, marginTop: 25 }}>9. Alterações</h2>
        <p>A política pode ser atualizada periodicamente.</p>

        <h2 style={{ fontSize: 20, marginTop: 25 }}>10. Contato – DPO</h2>
        <p>
          E-mails: <b>barretohigor01@gmail.com</b> — <b>leovthomase@gmail.com</b>
        </p>
      </section>

      <h1 style={{ fontSize: 26, marginTop: 40, marginBottom: 10 }}>
        TERMOS DE USO DO PROJETO “MARCA AÍ”
      </h1>

      <section style={{ marginBottom: 40 }}>
        <h2 style={{ fontSize: 20, marginTop: 25 }}>Introdução</h2>
        <p>
          Bem-vindo(a) ao “Marca Aí”! Estes termos regulam o uso da plataforma
          destinada à gestão de agendamentos.
        </p>

        <h2 style={{ fontSize: 20, marginTop: 25 }}>1. Aceitação</h2>
        <p>Ao usar a plataforma, você aceita estes termos e a Política.</p>

        <h2 style={{ fontSize: 20, marginTop: 25 }}>2. Elegibilidade</h2>
        <p>É necessário ser maior de idade ou legalmente capaz.</p>

        <h2 style={{ fontSize: 20, marginTop: 25 }}>3. Segurança da Conta</h2>
        <ul style={{ marginLeft: 20 }}>
          <li>Manter dados corretos</li>
          <li>Manter senha segura</li>
        </ul>

        <h2 style={{ fontSize: 20, marginTop: 25 }}>4. Uso da Plataforma</h2>
        <ul style={{ marginLeft: 20 }}>
          <li>Usar de forma ética</li>
          <li>Não publicar ofensas</li>
        </ul>

        <h2 style={{ fontSize: 20, marginTop: 25 }}>5. Assinaturas</h2>
        <p>Planos serão exibidos na plataforma.</p>

        <h2 style={{ fontSize: 20, marginTop: 25 }}>6. Propriedade Intelectual</h2>
        <p>Todo conteúdo pertence ao projeto.</p>

        <h2 style={{ fontSize: 20, marginTop: 25 }}>7. Limitação</h2>
        <ul style={{ marginLeft: 20 }}>
          <li>Plataforma pode ficar indisponível</li>
        </ul>

        <h2 style={{ fontSize: 20, marginTop: 25 }}>8. Rescisão</h2>
        <p>Conta pode ser encerrada por violação.</p>

        <h2 style={{ fontSize: 20, marginTop: 25 }}>9. Alterações</h2>
        <p>Os termos podem ser atualizados.</p>

        <h2 style={{ fontSize: 20, marginTop: 25 }}>10. Lei Aplicável</h2>
        <p>Foro: Americana/SP.</p>

        <h2 style={{ fontSize: 20, marginTop: 25 }}>11. Contato</h2>
        <p>
          E-mails: <b>barretohigor01@gmail.com</b> — <b>leovthomase@gmail.com</b>
        </p>
      </section>
    </div>
  );
}